import React from 'react';
import '../cs/temp.css';
import '../cs/te.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';

function DataScience() {
     useEffect(()=>{
    AOS.init({duration:1000, once:true})
     },[])
  return (
    <div className="webdev-page" style={{overflowX:"hidden"}}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content">
              <h1 className="inner-title">Data Science</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section data-science-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header ">
              <h2 data-aos="fade-up">Stand out online, get ahead of the competition</h2>
            <p className="intro-text">
            Unlock the hidden potential of your data! Dive into the world of Data Science to uncover powerful insights, leverage advanced analytics, and make smarter, data-driven decisions. With our expertise in machine learning, predictive modeling, and data visualization, we help businesses stay ahead in today’s information-driven world.
            </p>
            </div>
            <div className="data-badges">
              <div className="badge">
                <i className="fas fa-chart-line"></i>
                <span>Predictive Analytics</span>
              </div>
              <div className="badge">
                <i className="fas fa-brain"></i>
                <span>Machine Learning</span>
              </div>
              <div className="badge">
                <i className="fas fa-chart-pie"></i>
                <span>Data Visualization</span>
              </div>
              <div className="badge">
                <i className="fas fa-cogs"></i>
                <span>Process Optimization</span>
              </div>
            </div>
          </div>
          <div className="intro-image data-science-graphic">
            <div className="data-orbit">
              <div className="core"></div>
              <div className="orbit orbit-1">
                <div className="particle p1"></div>
              </div>
              <div className="orbit orbit-2">
                <div className="particle p2"></div>
              </div>
              <div className="orbit orbit-3">
                <div className="particle p3"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Data-Driven Journey Section */}
      {/* <section className="data-journey-section">
        <div className="container">
          <div className="section-header">
            <h2>Embark on a Data-Driven Journey</h2>
          </div>
          <div className="journey-content">
            <p>
              Embark on a data-driven journey with our blog dedicated to the fascinating realm of data science. From exploring advanced analytics to demystifying machine learning, we provide valuable insights for both beginners and seasoned professionals. Stay informed about the latest trends, best practices, and success stories in the dynamic field of data science. Join us in unraveling the power of data and transforming information into actionable intelligence.
            </p>
            <div className="journey-image">
              <img src="/assets/images/data-science-2.jpg" alt="Data Science Journey" />
            </div>
          </div>
        </div>
      </section> */}

      {/* Our Services Section */}
      <section className="webdev-services-section data-science-services">
        <div className="container">
          <div className="section-header">
            <h2>Our Data Science Services</h2>
            <p className="section-description">
              Comprehensive data science solutions to transform your business through advanced analytics
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="100">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-project-diagram"></i>
              </div>
              <h3>Predictive Modeling</h3>
              <p>Build forecasting models to predict future trends, optimize strategies, and reduce risks.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>Machine Learning Solutions</h3>
              <p>Develop custom algorithms to automate decision-making and uncover hidden patterns.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-chart-bar"></i>
              </div>
              <h3>Data Visualization</h3>
              <p>Transform complex datasets into clear, interactive dashboards for actionable insights.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-database"></i>
              </div>
              <h3>Big Data Processing</h3>
              <p>Analyze massive datasets with scalable, high-performance data processing systems.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-clipboard-list"></i>
              </div>
              <h3>Statistical Analysis</h3>
              <p>Validate hypotheses and uncover correlations using advanced statistical techniques.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-user-check"></i>
              </div>
              <h3>Customer Segmentation</h3>
              <p>Segment customers into targeted groups to enable personalization and boost engagement.</p>
            </div>
          </div>
        </div>
      </section>

      

      {/* Our Process Section */}
      <section className="design-process-section data-science-process">
        <div className="container">
          <div className="section-header">
            <h2>Our Data Science Process</h2>
            <p className="section-description">
              A structured approach to transforming raw data into valuable business insights
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "Data Collection & Integration",
                text: "Gather and unify data from multiple sources for a complete view of your business."
              },
              {
                num: 2,
                title: "Data Cleaning & Preparation",
                text: "Ensure accuracy and consistency by handling missing values, outliers, and formatting."
              },
              {
                num: 3,
                title: "Exploratory Data Analysis",
                text: "Identify patterns, anomalies, and relationships that drive meaningful insights."
              },
              {
                num: 4,
                title: "Model Development",
                text: "Design and train predictive models and ML solutions tailored to your goals."
              },
              {
                num: 5,
                title: "Validation & Optimization",
                text: "Test and fine-tune models to achieve maximum accuracy and performance."
              },
              {
                num: 6,
                title: "Deployment & Integration",
                text: "Seamlessly integrate insights into your business operations and decision-making tools."
              },
              {
                num: 7,
                title: "Monitoring & Refinement",
                text: "Continuously track model performance and refine strategies for ongoing improvement."
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Data Science Capabilities Section */}
      <section className="webdev-services-section data-science-services">
        <div className="container">
          <div className="section-header">
            <h2>Empower Your Business with Data Science</h2>
          </div>
          <div className="capabilities-content">
            <p className="capabilities-intro">
              Empower your business with our comprehensive Data Science services. Our expert team leverages cutting-edge algorithms, machine learning models, and statistical analysis to extract meaningful insights from your data. Whether you're looking to enhance decision-making, optimize processes, or unlock new opportunities, our tailored Data Science solutions are designed to meet your unique needs.
            </p>
            <div className="services-grid" data-aos="fade-left" data-aos-delay="200">
              <div className="service-card">
                <div className="service-icon">
                  <i className="fas fa-lightbulb"></i>
                </div>
                <h3>Enhanced Decision-Making</h3>
                <p>Make informed decisions backed by data-driven insights.
</p>
              </div>
              
              <div className="service-card">
                <div className="service-icon">
                  <i className="fas fa-rocket"></i>
                </div>
                <h3>Process Optimization</h3>
                <p>Identify inefficiencies and optimize workflows with analytics.</p>
              </div>
              
              {/* <div className="services-card">
                <div className="services-icon">
                  <i className="fas fa-unlock-alt"></i>
                </div>
                <h3>New Opportunities</h3>
                <p>Discover untapped markets and revenue streams through data exploration.</p>
              </div> */}
              
              <div className="service-card">
                <div className="service-icon">
                  <i className="fas fa-chart-pie"></i>
                </div>
                <h3>Data Visualization</h3>
                <p> Unlock new revenue streams and opportunities with actionable intelligence.</p>
              </div>
            </div>
            <p className="capabilities-conclusion mt-4 ">
            From predictive analytics to machine learning solutions, we guide you through every stage of your data journey, helping your organization fully leverage its data for smarter, faster, and better decisions.
            </p>
          </div>
        </div>
      </section>
    

      {/* CTA Section */}
      <section className="cta-section mt-5 data-science-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Data into Competitive Advantage?</h2>
            <p>Let's harness the power of data science to unlock insights and drive innovation for your business.</p>
            <a href="/contact" className="cta-button">Get a Free Data Science Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DataScience;
